export enum GenderType {
  Male = "Masculino",
  Female = "Feminino",
  Unknow = "Outros",
}
